import { Component, ViewChild } from '@angular/core';
import { ScrBaseComponent } from '../../../base.component';
import { LinkedAccountsNavigatorComponent } from '../linked-accounts-navigator/linked-accounts-navigator.component';

@Component({
  selector: 'app-linked-accounts-needs-action',
  templateUrl: './linked-accounts-needs-action.component.html'
})
export class LinkedAccountsNeedsActionComponent extends ScrBaseComponent {

  @ViewChild(LinkedAccountsNavigatorComponent) navigator!: LinkedAccountsNavigatorComponent;

  public interceptAction(accountId: number, fct: () => void): void {
    this.navigator.linkedAccountConfirm(accountId, fct);
  }
}
